const locale = {
  ALL: 'All',
  SPECIALIZED: 'Specialized',
  HUMAN: 'Human',
};

export default locale;
